import { Link } from 'react-router-dom';
import type { TVShow } from '@/mocks/tvShows';

interface ShowCardProps {
  show: TVShow;
}

export default function ShowCard({ show }: ShowCardProps) {
  const statusBadge = () => {
    if (show.status === 'hot') {
      return (
        <span className="absolute top-2 left-2 bg-primary-500 text-background-50 text-xs px-2 py-0.5 rounded-md font-medium whitespace-nowrap">
          热播
        </span>
      );
    }
    if (show.status === 'updating') {
      return (
        <span className="absolute top-2 left-2 bg-accent-500 text-background-50 text-xs px-2 py-0.5 rounded-md font-medium whitespace-nowrap">
          更新至{show.currentEpisode}集
        </span>
      );
    }
    return (
      <span className="absolute top-2 left-2 bg-secondary-500 text-background-50 text-xs px-2 py-0.5 rounded-md font-medium whitespace-nowrap">
        全{show.episodeCount}集
      </span>
    );
  };

  return (
    <Link
      to={`/detail/${show.id}`}
      className="group block cursor-pointer"
    >
      <div className="relative overflow-hidden rounded-lg aspect-[3/4] mb-3" data-product-shop="">
        <img
          src={show.coverImage}
          alt={show.title}
          title={`${show.title} - 天堂影视`}
          className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/70 via-transparent to-transparent"></div>
        {statusBadge()}
        <div className="absolute top-2 right-2 bg-foreground-950/70 text-amber-400 text-xs px-1.5 py-0.5 rounded-md flex items-center gap-0.5 font-medium">
          <i className="ri-star-fill text-[10px]"></i>
          {show.rating}
        </div>
        <div className="absolute bottom-0 left-0 right-0 p-3">
          <p className="text-xs text-background-50/80">{show.year} · {show.region}</p>
        </div>
      </div>
      <h3 className="text-sm font-semibold text-foreground-900 group-hover:text-primary-500 transition-colors line-clamp-1">
        {show.title}
      </h3>
      <p className="text-xs text-foreground-400 mt-1 line-clamp-1">{show.subTitle}</p>
    </Link>
  );
}